import { useBooking } from '../hooks/useBooking';
import { useSiteColors } from '../hooks/useSiteColors';
import { getOrderedSections } from '../lib/websiteSectionOrder';
import { NavBar } from './sections/NavBar';
import { HeroSection } from './sections/HeroSection';
import { TrustBar } from './sections/TrustBar';
import { ServicesSection } from './sections/ServicesSection';
import { AboutSection } from './sections/AboutSection';
import { ReviewsSection } from './sections/ReviewsSection';
import { BookingCTABanner } from './sections/BookingCTABanner';
import { FaqSection } from './sections/FaqSection';
import { ContactSection } from './sections/ContactSection';
import { LocationSection } from './sections/LocationSection';
import { SiteFooter } from './sections/SiteFooter';

function ContactLayout() {
  const { locations, businessListing } = useBooking();
  const c = useSiteColors();
  const hasLocationData =
    locations.length > 0 ||
    Boolean(businessListing?.address?.trim()) ||
    Boolean(businessListing?.google_place_id?.trim());

  return (
    <section id="location" className="py-20">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="mb-12">
          <p className="text-xs font-semibold tracking-[0.1em] uppercase mb-3" style={{ color: c.link }}>
            Get in Touch
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight" style={{ color: c.text }}>
            Contact us
          </h2>
        </div>
        <div className={`grid grid-cols-1 ${hasLocationData ? 'lg:grid-cols-2 gap-10' : ''}`}>
          <ContactSection />
          {hasLocationData && <LocationSection />}
        </div>
      </div>
    </section>
  );
}

/** The business's landing page: one look, in the colors chosen in the app's Website Basics. */
export function HomePage() {
  const { businessListing } = useBooking();
  const c = useSiteColors();
  const heroLayout = businessListing?.hero_layout ?? 'split';
  const sectionOrder = getOrderedSections(businessListing?.sections);

  return (
    <div className="min-h-screen" style={{ backgroundColor: c.background, color: c.text }}>
      <NavBar />
      {sectionOrder.map(id => {
        switch (id) {
          case 'hero':
            return <HeroSection key={id} layout={heroLayout} />;
          case 'trust':
            return <TrustBar key={id} />;
          case 'services':
            return <ServicesSection key={id} />;
          case 'about':
            return <AboutSection key={id} />;
          case 'reviews':
            return <ReviewsSection key={id} />;
          case 'booking_cta':
            return <BookingCTABanner key={id} />;
          case 'faq':
            return <FaqSection key={id} />;
          case 'location':
            return <ContactLayout key={id} />;
          default:
            return null;
        }
      })}
      <SiteFooter />
    </div>
  );
}
